// Switch Season 2021 Module
// Licensed under Apache 2 (http://www.apache.org/licenses/LICENSE-2.0)
// DO NOT MODIFY

// Core JavaScript here

/* global YT, gsap, ScrollTrigger, scrollTo, innerHeight */

Wee.fn.make('switchSeason2021', {
	_construct: function() {
		this.activeClass = '-is-active';
		this.currentSection = null;
		this.$choicesModal = $('ref:choicesModal');
	},
	init: function() {
		var scope = this;

		$.events.on({
			'window': {
				keyup: function(e) {
					if (e.key === 'Escape' || e.key === 'Esc') {
						scope.closeChoisesDetail();
						scope.closeSolutionPanels();
					}
				}
			},
			'ref:toggleChoices': {
				click: function() {
					scope.showChoicesDetail();
				}
			},
			'ref:closeChoices': {
				click: function() {
					scope.closeChoisesDetail();
				}
			},
			'ref:solutionOpen': {
				click: function(e, el) {
					scope.openSolutionPanel(el);
				}
			},
			'ref:shopSolutionsTrigger': {
				click: function(e, el) {
					scope.openSolutionsShopLink(e, el);
				}
			}
		});

		if ($('ref:experienceIntro').length) {
			scope.initSwitchIntroExperience(scope);
		}

		if ($('ref:pageIntro').length) {
			scope.initPageIntroSlides(scope);
		}

		if ($('ref:videoBlock').length) {
			scope.initVideoElements(scope);
		}

		if ($('ref:switchConnectForm').length) {
			scope.initConnectForm($('ref:switchConnectForm'));
		}
	},

	closeChoisesDetail: function() {
		this.$choicesModal.removeClass(this.activeClass);
	},

	showChoicesDetail: function() {
		this.$choicesModal.addClass(this.activeClass);
	},

	gsapHide: function(elem) {
		gsap.set(elem, {
			autoAlpha: 0
		});
	},

	gsapAnimateFrom: function(elem, direction) {
		direction = direction || 1;
		var x = 0,
			y = direction * 100;

		if (elem.classList.contains('gs_reveal_fromLeft')) {
			x = -200;
			y = 0;
		} else if (elem.classList.contains('gs_reveal_fromRight')) {
			x = 200;
			y = 0;
		} else if (elem.classList.contains('gs_reveal_fromBottom')) {
			x = 0;
			y = 200;
		} else if (elem.classList.contains('gs_reveal_fadeIn')) {
			x = 0;
			y = 50;
		}
		elem.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
		elem.style.opacity = '0';
		gsap.fromTo(elem, {
			x: x,
			y: y,
			autoAlpha: 0
		}, {
			duration: 1.25,
			x: 0,
			y: 0,
			autoAlpha: 1,
			ease: 'expo'
		});
	},

	gsapSetSection: function(newSection, scope) {
		if (newSection !== scope.currentSection) {
			gsap.to(scope.currentSection, {
				scale: 1,
				autoAlpha: 0
			});
			gsap.to(newSection, {
				scale: 1,
				autoAlpha: 1
			});
			scope.currentSection = newSection;
		}
	},

	initSwitchIntroExperience: function(scope) {
		gsap.registerPlugin(ScrollTrigger);
		gsap.registerPlugin(scrollTo);

		$('ref:viewChoices').on('click', function() {
			gsap.to(window, {
				duration: 0.75,
				scrollTo: {
					y: 'max'
				}
			});
		});

		var sections = gsap.utils.toArray('.scrollBlock');

		scope.currentSection = sections[0];

		gsap.defaults({
			overwrite: 'auto',
			duration: 1
		});

		gsap.set('.scroller', {
			height: (sections.length * 100) + 'vh'
		});

		sections.forEach(function(section, i) {
			ScrollTrigger.create({
				anticipatePin: true,
				scrub: 1,
				pin: false,
				preventOverlaps: true,
				fastScrollEnd: true,
				start: function() {
					return (i - 0.5) * innerHeight;
				},
				end: function() {
					return (i + 0.5) * innerHeight;
				},
				onToggle: function(self) {
					self.isActive;
					scope.gsapSetSection(section, scope);
				}
			});
		});
	},

	initPageIntroSlides: function(scope) {
		gsap.registerPlugin(ScrollTrigger);

		gsap.utils.toArray('.gs_reveal').forEach(function(elem) {
			scope.gsapHide(elem);

			ScrollTrigger.create({
				trigger: elem,
				start: 'center bottom',
				once: true,
				onEnter: function() {
					scope.gsapAnimateFrom(elem);
				}
			});
		});
	},

	initVideoElements: function() {
		var currentPlayer = false;

		$.assets.load({
			js: 'https://www.youtube.com/iframe_api'
		});

		$.events.on('ref:videoToggle', 'click', function() {
			if (currentPlayer) {
				switch (currentPlayer.getPlayerState()) {
					case -1:
						currentPlayer.playVideo();
						break;

					case 0:
						currentPlayer.seekTo(0).playVideo();
						break;

					case 1:
						currentPlayer.pauseVideo();
						break;

					case 2:
						currentPlayer.playVideo();
						break;

					default:
						currentPlayer.seekTo(0).playVideo();
						break;
				}
			} else {
				currentPlayer = new YT.Player('js-video', {
					videoId: $.get('videoId'),
					enablejsapi: 1,
					origin: $.routes.uri(),
					startSeconds: 0,
					playerVars: {
						showinfo: 0,
						modestbranding: 1,
						rel: 0
					},
					events: {
						'onReady': function(event) {
							$('ref:imageWrapper').hide();
							event.target.playVideo();
						}
					}
				});
			}
		});
	},

	initConnectForm: function($form) {
		// Bind form submission
		$form.on('submit', function(e) {
			$.fetch.request({
				url: $form.attr('action'),
				method: 'post',
				data: $form.serialize(),
				type: 'form',
				json: true,
				success: function(response) {
					var success = response.success,
						finished = response.finished,
						actions = response.actions ? response.actions : [],
						errors = response.errors,
						formErrors = response.formErrors,
						honeypot = response.honeypot;

					// Reset error messages
					$form.find('ref:errorMessage');

					if (! actions.length) {
						if (success && finished) {
							$('switch-connect__input').val('');
							$('ref:errorMessage').hide();
							$('ref:successMessage').text('Thanks! We will be in touch soon.');
						} else if (errors || formErrors) {
							console.error(errors, formErrors);
							$('ref:errorMessage').text(errors);
						}
					} else {
						console.log(errors, formErrors);
					}

					if (honeypot) {
						var $honeypotInput = $('input[name^=freeform_form_handle]');

						if ($honeypotInput) {
							$honeypotInput.attr('name', honeypot.name);
							$honeypotInput.attr('id', honeypot.name);
							$honeypotInput.value = honeypot.hash;
						}
					}
				}
			});

			e.preventDefault();
		});
	},

	closeSolutionPanels: function() {
		$('ref:solutionBlock').removeClass(this.activeClass);
	},

	openSolutionPanel: function(element) {
		if ($(element).parent('ref:solutionBlock').hasClass(this.activeClass)) {
			$('ref:solutionBlock').removeClass(this.activeClass);
		} else {
			$('ref:solutionBlock').removeClass(this.activeClass);
			$(element).parent('ref:solutionBlock').addClass(this.activeClass);
		}
	},

	openSolutionsShopLink: function(event) {
		var destinationUrl = $(event.srcElement).siblings('ref:shopSolutionsSelectWrap').children('select').val();

		window.open(destinationUrl, '_blank').focus();
	}
});

Wee.switchSeason2021.init();
